import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import useUserState from '../../../../hooks/useUserState';
import { PermissionName } from '../../../../types/Auth';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

interface actionsColumns {
  onClickEdit: (row: any) => void;
  onClickDelete: (row: any) => void;
}

export default function useColumnActions({
  onClickEdit,
  onClickDelete,
}: actionsColumns): ColumnTable[] {
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_INSTITUTIONS);
  const { isAuthorizedTo } = useUserState();

  const showSave = useMemo(() => {
    return !!isAuthorizedTo([PermissionName.SETTINGS]);
  }, [isAuthorizedTo]);

  return [
    {
      columnName: 'Acciones',
      headerText: t('table.actions'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ row }) => {
        return showSave ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: 2 }}
          >
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => onClickEdit(row)}
            >
              <Icon name="edit" />
            </button>
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => onClickDelete(row)}
            >
              <Icon name="trash" />
            </button>
          </div>
        ) : (
          <></>
        );
      },
    },
  ];
}
